module.exports = __webpack_public_path__ + "static/Loan-6318b2b1d69331aab9ba0bd79230140c.png";